// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3_gnt","header":"header__3xb3k","browser":"browser__1mIPz","browserLink":"browserLink__1gdzp"};


//////////////////
// WEBPACK FOOTER
// ./components/unsupported-browsers/style.scss
// module id = nRW3
// module chunks = 27